<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基金代码">
              <a-input
                placeholder="请输入基金代码"
                v-model="queryParam.fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        :rowKey="(record) => record.id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
      </a-table>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { uploadAction } from '@/api/manage';
import { getAction } from '../../../api/manage';
import customRender from '@/utils/customRender.js';
import { netValueEdit } from '@/api/product';

export default {
  name: 'portfolioManagement',
  data() {
    return {
      description: '资产组合管理页面',
      showDialog: false,
      fileList: [],
      uploading: false,
      loading: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      queryParam: {
        fundCode: '',
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '季报名称',
          align: 'center',
          dataIndex: 'name',
          customRender: customRender,
          width: 60,
        },
        {
          title: '基金代码',
          align: 'center',
          dataIndex: 'fundCode',
          customRender: customRender,
          width: 100,
        },
        {
          title: '项目名称',
          align: 'center',
          dataIndex: 'project',
          customRender: customRender,
          width: 100,
        },
        {
          title: '金额',
          align: 'center',
          dataIndex: 'amount',
          customRender: customRender,
          width: 100,
        },
        {
          title: '占基金总资产的比例（%）',
          align: 'center',
          dataIndex: 'scale',
          customRender: customRender,
          width: 100,
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkStatus',
          customRender: (text) => {
            if (text == 0) {
              return '待审核';
            } else if (text == 1) {
              return '已审核';
            } else if (text == 1) {
              return '已驳回';
            } else if (text == '' || text == null) {
              return '--';
            } else {
              return text;
            }
          },
          width: 80,
        },
        {
          title: '发布状态',
          align: 'center',
          dataIndex: 'publishStatus',
          customRender: (text) => {
            if (text == 0) {
              return '待发布';
            } else if (text == 1) {
              return '已发布';
            } else if (text == '' || text == null) {
              return '--';
            } else {
              return text;
            }
          },
          width: 80,
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/zzzh/list',
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        fundCode: that.queryParam.fundCode,
        type: 0,
      };
      that.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },
    handlePublish(records) {
      console.log(records);
      let params = {
        id: records.id,
        manualIncomeRatio: records.manualIncomeRatio,
        manualIncomeUnit: records.manualIncomeUnit,
        manualNetValue: records.manualNetValue,
        manualTotalNetValue: records.manualTotalNetValue,
      };
      netValueEdit(params).then((res) => {
        if (res.success) {
          this.getList();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
